/**
 * FranceConnectBientotPage — écran affiché quand on clique « Récupérer via
 * FranceConnect » alors que l'intégration n'est pas encore activée (pas de codes
 * d'habilitation). Évite de tomber sur une page vide.
 *
 * Dès que FRANCECONNECT_ENABLED=true + secrets sont posés, le bouton ne passe
 * plus par ici : il redirige vers la vraie mire FranceConnect.
 */

import { useNavigate } from 'react-router-dom';
import { ShieldCheck, ArrowLeft, Clock } from 'lucide-react';
import { Card, CardBody, Button, Badge } from '@/components/ui';
import { AppHeader } from '@/components/AppHeader';

export function FranceConnectBientotPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen text-ink">
      <AppHeader module="Scolaire & cantine" accent="cantine" />
      <main className="mx-auto flex max-w-xl flex-col items-center px-4 py-12 text-center">
        <span className="mb-4 inline-grid h-14 w-14 place-items-center rounded-r-xl bg-cantine-tint text-cantine-fg" aria-hidden="true">
          <ShieldCheck className="h-7 w-7" />
        </span>
        <Badge variant="info" className="mb-3"><Clock className="mr-1 h-3 w-3" /> Bientôt disponible</Badge>
        <h1 className="font-display text-2xl font-semibold text-ink">Connexion FranceConnect</h1>
        <p className="mt-3 text-ink-muted">
          La récupération automatique de votre quotient familial via FranceConnect
          sera activée prochainement, une fois l'habilitation de la commune obtenue
          auprès des services de l'État.
        </p>
        <p className="mt-2 text-sm text-ink-subtle">
          En attendant, votre quotient familial peut être saisi par la mairie.
          Aucune action n'est requise de votre part pour le moment.
        </p>
        <Card className="mt-6 w-full">
          <CardBody>
            <Button variant="cantine" onClick={() => navigate('/scolaire-cantine')}>
              <ArrowLeft className="h-4 w-4" /> Revenir à mon espace
            </Button>
          </CardBody>
        </Card>
      </main>
    </div>
  );
}
